<template>
    <div>
        <img src="../../assets/img/bg-learn.png" alt="" style="width: 100vw;">
    </div>
</template>

<script>
export default {

}
</script>

<style scoped></style>